export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q04_a.4a553e20.png";